import { constrain } from './helpers';

function setRevealPosition($slider, pos) {
	$slider.find('.reveal-slider-section-left').css('width', pos);
	$slider.find('.reveal-slider-separator').css('left', pos);

	if (pos > $(window).width() / 2) {
		$slider.find('.reveal-slider-section-left').addClass('active');
		$slider.find('.reveal-slider-section-right').removeClass('active');
		$slider.find('.reveal-slider-handle-right').addClass('active');
		$slider.find('.reveal-slider-handle-left').removeClass('active');
	} else {
		$slider.find('.reveal-slider-section-left').removeClass('active');
		$slider.find('.reveal-slider-section-right').addClass('active');
		$slider.find('.reveal-slider-handle-right').removeClass('active');
		$slider.find('.reveal-slider-handle-left').addClass('active');
	}
}

function animateTo($slider, x, target) {
	$(x).animate({
		position: target
	}, {
		duration: 600,
		easing: 'swing',
		step(now) {
			setRevealPosition($slider, now);
		}
	});
}

$(document).ready(function () {
	if ($(window).width() > 1025) {

		const snapThreshold = 0.1;

		$('.reveal-slider').each(function () {
			const $slider = $(this);

			const x = {
				min: 0,
				max: $(window).width(),
				position: 0,
				offset: 0
			};

			x.position = x.max * 0.2;

			let dragging = false;

			setRevealPosition($slider, x.position);

			$(this).on('mousemove', function (e) {
				const mouseX = e.clientX;

				if (dragging) {
					const expected = mouseX - x.offset;
					x.position = constrain(expected, 0, $slider.width());
					setRevealPosition($slider, x.position);
				}
			});

			$slider.find('.reveal-slider-separator').on('mousedown touchstart', function(e) {
				x.offset = e.clientX - $(this).offset().left;
				dragging = true;
				$slider.addClass('dragging');
			});

			$(window).on('mouseup touchend blur', () => {
				x.offset = 0;
				dragging = false;
				$slider.removeClass('dragging');
				if ($(window).width() > x.position && x.position > $(window).width() * (1 - snapThreshold)) {
					animateTo($slider, x, $(window).width());
				}

				if (0 < x.position && x.position < $(window).width() * snapThreshold) {
					animateTo($slider, x, 0);
				}
			});

			$('.reveal-slider-handle-left').on('dblclick', function () {
				animateTo($slider, x, 0);
			});

			$('.reveal-slider-handle-right').on('dblclick', function () {
				animateTo($slider, x, $(window).width());
			});
		});

	}
});
